"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaField = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var UIComponents_1 = require("./UIComponents");
var TextAreaFieldView = function (_a) {
    var name = _a.name, label = _a.label, description = _a.description, sideDescription = _a.sideDescription, className = _a.className, maxLength = _a.maxLength, props = __rest(_a, ["name", "label", "description", "sideDescription", "className", "maxLength"]);
    var _b = (0, formik_1.useField)(name), field = _b[0], meta = _b[1], _ = _b[2];
    var fieldLength = String(field.value || "").length;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(UIComponents_1.ui.Label, { label: label, description: description, sideDescription: sideDescription }),
        react_1.default.createElement(Input, __assign({ error: !!(meta.error && meta.touched) }, field, props)),
        react_1.default.createElement(InfoRow, null,
            react_1.default.createElement(UIComponents_1.ui.ErrorMessage, { showError: !!(meta.touched && meta.error), message: meta.error }),
            maxLength !== undefined && (react_1.default.createElement(Text_1.Text, { mt: "4px", ml: "auto", pl: "4px", variant: "uiTiny500", color: fieldLength > maxLength ? "red700" : "gray600" }, "".concat(fieldLength, "/").concat(maxLength))))));
};
/**
 * TextArea input field. Must be wrapped in a Formik provider.
 * @param {string} name - The field name, used as reference by formik
 * @param {string} label - Label for this input, used to provide context to the user
 * @param {string=} description - Secondary label used to provide additional context to the user
 */
exports.TextAreaField = (0, styled_1.default)(TextAreaFieldView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 320px;\n  ", "\n  ", "\n"], ["\n  width: 320px;\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.layout);
var Input = styled_1.default.textarea(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  margin: 0;\n  resize: none;\n  width: 100%;\n  ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  &:active,\n  &:focus {\n    &:not(:disabled) {\n      outline: none;\n      ", "\n    }\n  }\n\n  ", "\n"], ["\n  ", "\n  margin: 0;\n  resize: none;\n  width: 100%;\n  ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  &:active,\n  &:focus {\n    &:not(:disabled) {\n      outline: none;\n      ", "\n    }\n  }\n\n  ", "\n"])), UIComponents_1.ui.baseStyles, Text_1.textStyles.paragraphLarge, theme_1.theme.colors.gray500, theme_1.theme.colors.gray200, UIComponents_1.ui.focusedStyles, function (_a) {
    var error = _a.error;
    return error && UIComponents_1.ui.errorStyles;
});
var InfoRow = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
